import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import t from '../../lib/I18n';
import Smartcard from '../../records/customer/Smartcard';
import { AccountPages } from '../../constants/AppConstants';
import Link from '../general/Link';


function _getStatusText (smartcard) {
    if (smartcard.isActive() && smartcard.isFull()) {
        return t('account.smartcard.status.full');
    }
    if (smartcard.isAwaitingProduct()) {
        return '';
    }
    return smartcard.getStatus();
}


function SmartcardStatus ({ smartcard }) {
    const classNames = classnames({
        'alert-success': smartcard.canLoadProduct(),
        'alert-warning': !smartcard.canLoadProduct()
    }, 'text-weight--normal', 'text-upper', 'no-margin');

    return (
        <p className={ classNames }>
            { _getStatusText(smartcard) + ' ' }

            { !smartcard.canLoadProduct() &&
                <Link className="alert-warning text-sm text-capitalise" to={ AccountPages.SMARTCARD_TICKETS }>
                    { t('booking.smartcard.moreInformation') }
                </Link>
            }
        </p>
    );
}


SmartcardStatus.propTypes = {
    smartcard: PropTypes.instanceOf(Smartcard).isRequired
};


export default SmartcardStatus;



// WEBPACK FOOTER //
// ./src/components/smartcard/Status.js